import { Trans } from '@lingui/macro'
import IncentivePositionListItem from 'components/IncentivePositionListItem'
import React from 'react'
import styled from 'styled-components/macro'
import { PositionDetails } from 'types/position'

const Header = styled.div`
  display: flex;
  font-size: 14px;
  font-weight: 500;
  padding: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.backgroundOutline};
`

type IncentivePositionListProps = React.PropsWithChildren<{
  positions: PositionDetails[]
}>

/**
 * A simplified version of PositionList that only shows open positions
 * and doesn't offer the ability to toggle closed positions
 */
export default function IncentivePositionList({ positions }: IncentivePositionListProps) {
  return (
    <>
      <Header>
        <Trans>Your positions</Trans>
        {positions && ` (${positions.length})`}
      </Header>
      {positions.map((p) => (
        <IncentivePositionListItem key={p.tokenId.toString()} {...p} />
      ))}
    </>
  )
}
